import { memo } from "react";
import { LinearProgressProps } from "@mui/material";
import { StyledLinearProgress } from "./progressBar.style";

const ProgressBar: React.FC<LinearProgressProps> = (props) => {
  return <StyledLinearProgress variant="determinate" {...props} />;
};

export default memo(ProgressBar);
